import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";
import { useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { TextInput } from "src/qubCommon/Inputs";
import RadioInput from "src/qubCommon/Inputs/RadioInput";
import { REVIEW_STATUS_IDS } from "./ExpenseDetailsGrid";

const FINAL_REVIEW_STATUS_OPTIONS = [
  { Value: REVIEW_STATUS_IDS.approved.toString(), Label: "Εγκεκριμένη" },
  {
    Value: REVIEW_STATUS_IDS.partiallyApproved.toString(),
    Label: "Μερικώς εγκεκριμένη",
  },
  { Value: REVIEW_STATUS_IDS.rejected.toString(), Label: "Απορριφθείσα" },
];

const getInitialValues = (statusId, comments) => ({
  statusId: statusId ?? "",
  comments: comments ?? "",
});

const FinalReviewDialog = ({
  open,
  statusId,
  comments = "",
  commentsOn = false,
  isSaving = false,
  onCancel,
  onConfirm,
}) => {
  const form = useForm({
    defaultValues: getInitialValues(statusId, comments),
  });
  const { handleSubmit, reset } = form;

  useEffect(() => {
    if (!open) return;

    reset(getInitialValues(statusId, comments));
  }, [comments, open, reset, statusId]);

  const handleConfirm = (values) => {
    onConfirm?.({
      statusId: values.statusId,
      comments: values.comments ?? "",
    });
  };

  return (
    <FormProvider {...form}>
      <Dialog open={open} onClose={onCancel} fullWidth maxWidth="sm">
        <DialogTitle variant="h4">Ολοκλήρωση Ελέγχου</DialogTitle>
        <DialogContent>
          <Stack spacing={2} sx={{ pt: 1 }}>
            <Typography>
              Ο τρέχων έλεγχος των γραμμών θα αποθηκευτεί πριν ολοκληρωθεί ο
              έλεγχος του παραστατικού.
            </Typography>
            <RadioInput
              name="statusId"
              label="Τελική Κατάσταση"
              options={FINAL_REVIEW_STATUS_OPTIONS}
            />
            {commentsOn && (
              <TextInput
                name="comments"
                label="Σχόλια Ελέγχου"
                defaultFromProps={false}
                multiline
                rows={4}
              />
            )}
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={onCancel} disabled={isSaving}>
            Άκυρο
          </Button>
          <Button
            variant="contained"
            color="success"
            onClick={handleSubmit(handleConfirm)}
            disabled={isSaving}
          >
            Ολοκλήρωση
          </Button>
        </DialogActions>
      </Dialog>
    </FormProvider>
  );
};

export default FinalReviewDialog;
